import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import useGetObjectEncs from 'hooks/ObjectEnc/useGetObjectEnc';
import useScreenSize from 'hooks/Screen/useScreenSize';
import { Encounter as ApiResponse } from 'api/encounters/types';
import { useGetObjectEncColumns } from 'hooks/ObjectEnc/useGetObjectEncColumns';
import AdvancedFilterDataTable from 'components/FilterDataTable/AdvancedFilterDataTable';
import ObjectEncsExpandable from 'components/ObjectEncs/ObjectEncsExpandable';
import AddEncounterOnMapModal from 'pages/InteractiveMap/components/Modals/AddEncOnMap/AddEncounterOnMapModal';
import ViewModal from 'components/ViewModal/ViewModal';

const Encounters: React.FC = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { isNotExtraLarge } = useScreenSize();
  const { data, isLoading, refetch } = useGetObjectEncs(slug || '');
  const columns = useGetObjectEncColumns(slug || '');
  const searchFields = ['status', 'place', 'discovery_date', 'pest_traces', 'amount'];
  const [advancedFilter, setAdvancedFilter] = useState('default');
  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);
  const filteredData = useMemo(() => {
    if (!data) return [];

    if (advancedFilter === 'activity_only') {
      return data.filter(item => item.status === 'danger' || item.status === 'warning');
    }
    if (advancedFilter === 'resolved_only') {
      return data.filter(item => item.status === 'success');
    }

    return data;
  }, [data, advancedFilter]);
  return (
    <div className="bg-white">
      <AdvancedFilterDataTable<ApiResponse>
        columns={columns}
        data={filteredData}
        onChangePage={setPage}
        amountPerPageLabel="Pest Sightings Page"
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        searchFields={searchFields}
        isLoading={isLoading}
        expandableRows={isNotExtraLarge}
        expandableRowsComponent={ObjectEncsExpandable}
        onChangeAdvancedFilter={setAdvancedFilter}
        isEncountersTable
        isSighting
      />
      <AddEncounterOnMapModal refetchEncounters={refetch} />
      <ViewModal />
    </div>
  );
};

export default Encounters;
